module.exports = __webpack_public_path__ + "img/choose.eb237d45.png";